<template>
  <div class="page bg-color">
    <div class="title">
      <div class="title-left">
        <div class="logo-demo">
          <img src="@/assets/images/logo.png" alt="">
        </div>
      </div>
      <div class="title-right">
        <div class="title-right-text-box">
          <div class="title-right-text">
            <div class="title-right-text-name">{{ maskString(username) }}</div>
          </div><img src="@/assets/images/mine-icon-36.png" alt="" class="img2">
        </div>
        <div class="title-img">
          <div class="van-badge__wrapper">
            <div class="title-img-box" @click="router.push('/mail')">
              <van-badge :content="information.all_num" :show-zero="false">
                <img src="@/assets/images/ld.svg" alt="">
              </van-badge>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="banner-box">
      <van-swipe class="my-swipe" :autoplay="4000" indicator-color="white">
        <van-swipe-item class="item" @click="router.push('/dayTrading')">
          <div class="item-box item1">
            <video class="bg-video" autoplay muted playsinline preload="auto" poster="@/assets/video/mp41.jpg" loop>
              <source src="@/assets/video/ysbanner2.mp4" type="video/mp4" />
            </video>
            <div class="name"><span>MatrixQuant</span>{{ t('index.a14') }}</div>
            <p class="msg">{{ t('index.a15') }}</p>
          </div>
        </van-swipe-item>
        <van-swipe-item class="item" @click="router.push('/otc')">
          <div class="item-box item2">
            <video class="bg-video" autoplay muted playsinline preload="auto" poster="@/assets/video/mp42.jpg" loop>
              <source src="@/assets/video/ysbanner1.mp4" type="video/mp4" />
            </video>
            <div class="name"><span>MatrixQuant</span></div>
            <p class="msg">{{ t('index.a16') }}</p>
          </div>
        </van-swipe-item>
        <van-swipe-item class="item" @click="goUrl">
          <div class="item-box item3">
            <!-- <div class="name"><span>MATRIX</span>{{ t('index.a14') }}</div>
            <p class="msg">多因子策略模型，动态调整仓位，精准识别趋势反转。</p> -->
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="content-box">
      <div class="menu2">
        <van-grid :column-num="4" :border="false">
          <van-grid-item to="/otc" :badge="information.otc_num ? information.otc_num : ''">
            <!-- <van-grid-item to="/otc"> -->
            <template #icon>
              <div class="icon-box">
                <img alt="" src="@/assets/images/bk1.jpg">
              </div>
            </template>
            <template #text>
              <div class="text-box">
                <span>{{ t('index.a17') }}</span>
              </div>
            </template>
          </van-grid-item>
          <van-grid-item to="/ipo" :badge="information.ipo_num ? information.ipo_num : ''">
            <template #icon>
              <div class="icon-box">
                <img alt="" src="@/assets/images/bk2.jpg">
              </div>
            </template>
            <template #text>
              <div class="text-box">
                <span>IPO</span>
              </div>
            </template>
          </van-grid-item>
          <van-grid-item to="/etf" :badge="information.etf_num ? information.etf_num : ''">
            <template #icon>
              <div class="icon-box">
                <img alt="" src="@/assets/images/bk3.jpg">
              </div> 
            </template>
            <template #text>
              <div class="text-box">
                <span>ETF</span>
              </div>
            </template>
          </van-grid-item>
          <van-grid-item to="/newsHighlights" :badge="information.ai_num ? information.ai_num : ''">
            <template #icon>
              <div class="icon-box">
                <img alt="" src="@/assets/images/bk42.svg">
              </div>
            </template>
            <template #text>
              <div class="text-box">
                <span>{{ t('index.a18') }}</span>
              </div>
            </template>
          </van-grid-item>
          <van-grid-item to="/realNameAuthentication">
            <template #icon>
              <div class="icon-box">
                <img alt="" src="@/assets/images/bk5.jpg">
                <img alt="" v-if="userInfo.is_realname == 0" class="gantanhao" src="@/assets/images/wtg.svg">
              </div>
            </template>
            <template #text>
              <div class="text-box">
                <span>{{ t('index.a3') }}</span>
              </div>
            </template>
          </van-grid-item>
          <van-grid-item @click="openService()" :badge="noRead ? noRead : ''">
            <template #icon>
              <div class="icon-box">
                <img alt="" src="@/assets/images/bk6.jpg">
              </div>
            </template>
            <template #text>
              <div class="text-box">
                <span>{{ t('index.a4') }}</span>
              </div>
            </template>
          </van-grid-item>
          <van-grid-item to="/about">
            <template #icon>
              <div class="icon-box">
                <img alt="" src="@/assets/images/bk7.jpg">
              </div>
            </template>
            <template #text>
              <div class="text-box">
                <span>{{ t('index.a19') }}</span>
              </div>
            </template>
          </van-grid-item>
          <van-grid-item to="/faq">
            <template #icon>
              <div class="icon-box">
                <img alt="" src="@/assets/images/bk8.jpg">
              </div>
            </template>
            <template #text>
              <div class="text-box">
                <span>{{ t('index.a20') }}</span>
              </div>
            </template>
          </van-grid-item>
        </van-grid>
      </div>
      <!-- 未实名 -->
      <!-- <div class="kyc" v-if="(userInfo.is_realname == 0 || userInfo.is_realname == 2)"
        @click="router.push('/realNameAuthentication')">
        <div class="lf">
          <img src="@/assets/images/sfrz.svg" alt="">
        </div>
        <div class="center">
          <p class="ps">{{ t('index.a22') }}</p>
          <p class="btnt">{{ t('index.a23') }} <img src="@/assets/images/jth.svg" alt=""></p>
        </div>
        <div class="rg">
          <img src="@/assets/images/lh.gif" alt="">
        </div>
      </div> -->
      <!-- 未领取 -->
      <!-- <div class="kyc" v-if="userInfo.is_realname == 1 && trial_info_home.is_use == 0"
        @click="router.push('/AiTrialBonus?id=' + trial_info_home.id)">
        <div class="lf">
          <img src="@/assets/images/sfrz2.svg" alt="">
        </div>
        <div class="center">
          <p class="ps">{{ t('index.a24') }}</p>
          <p class="btnt">{{ t('index.a25') }} <img src="@/assets/images/jth.svg" alt=""></p>
        </div>
        <div class="rg">
          <img src="@/assets/images/lh.gif" alt="">
        </div>
      </div> -->
      <!-- 已领取 -->
      <!-- <div class="kyc" v-if="userInfo.is_realname == 1 && trial_info_home.is_use == 1"
        @click="router.push('/AiTrialBonus?id=' + trial_info_home.id)">
        <div class="lf">
          <img src="@/assets/images/sfrz3.svg" alt="">
        </div>
        <div class="center">
          <p class="ps">{{ t('index.a26') }}</p>
          <p class="btnt">{{ t('index.a27') }} <img src="@/assets/images/jth.svg" alt=""></p>
        </div>
        <div class="rg">
          <img src="@/assets/images/lh.gif" alt="">
        </div>
      </div> -->

      <div class="zc-box">
        <div class="zc-con">
          <div class="name">
            {{ t('index.a31') }}
            <van-icon @click="isShowAmount = !isShowAmount" class="icon" :name="isShowAmount ? 'eye' : 'closed-eye'"
              style="color: #000000;" />
          </div>
          <div class="value" v-if="isShowAmount">
            {{ $usd(pageData.balance_ar) }}
            <div class="yk-val zf" :class="{ zlass: pageData.income_ar > 0, dlass: pageData.income_ar <= 0 }">
              {{ $usd(pageData.income_ar) }}
            </div>
          </div>
          <div class="value" v-else>
            ********
            <div class="yk-val zf" :class="{ zlass: pageData.income_ar > 0, dlass: pageData.income_ar <= 0 }">
              ********
            </div>
          </div>
        </div>
      </div>
      <div class="qqzs">
        <div class="popular-stocks">
          <div class="text">{{ t('index.a5') }}</div>
          <!-- <div @click="router.push('/market')"> {{ t('index.a6') }} <van-icon name="arrow" /></div> -->
        </div>
        <!-- <RollingIndex :list="indexs" v-if="indexs.length" /> -->
        <RollingIndex2 :list="indexs" v-if="indexs.length" />
      </div>
      <div class="qqzs">
        <div class="popular-stocks">
          <div class="text">{{ t('index.a7') }}</div>
          <div @click="router.push('/market')"> {{ t('index.a6') }} <van-icon name="arrow" /></div>
        </div>
        <div class="list-page">
          <div class="list-page-tabs">
            <div class="list-page-tabs-item" :class="{ selected: active == 0 }" @click="tabChange(0)"> {{ t('index.a8')
            }}
            </div>
            <!-- <div class="list-page-tabs-item" :class="{ selected: active == 1 }" @click="tabChange(1)"> {{ t('index.a9')
            }}
            </div> -->
            <div class="list-page-tabs-item" :class="{ selected: active == 2 }" @click="tabChange(2)"> {{ t('index.a10')
            }}
            </div>
          </div>
          <div class="list-th" v-if="active != 3">
            <div>{{ t('market.a7') }}</div>
            <div style="text-align: center;display: flex;align-items: center;">
              {{ active != 0 ? t('index.a12', { value: active == 1 ? 'ARS' : 'USD' }) : t('index.a28') }}
              <div class="list-th-right-icon" @click="sortClick('price')">
                <van-icon class="icon" name="arrow-up"
                  :style="`color:${sort == 1 && sort_field == 'price' ? '#2969FF' : '#000'}`" />
                <van-icon class="icon icon-fall" name="arrow-down"
                  :style="`color:${sort == 2 && sort_field == 'price' ? '#2969FF' : '#000'}`" />
              </div>
            </div>
            <div class="list-th-right">
              <div style="width: fit-content;display: flex;align-items: center;">{{ t('market.a9') }}</div>
              <div class="list-th-right-icon" @click="sortClick('changes_percentage')">
                <van-icon class="icon" name="arrow-up"
                  :style="`color:${sort == 1 && sort_field == 'changes_percentage' ? '#2969FF' : '#000'}`" />
                <van-icon class="icon icon-fall" name="arrow-down"
                  :style="`color:${sort == 2 && sort_field == 'changes_percentage' ? '#2969FF' : '#000'}`" />
              </div>
            </div>
          </div>
          <div class="list">
            <div class="list-row" v-for="v in list" :key="v.id" @click="router.push('/marketDetail?id=' + v.id)">
              <div class="list-col1">
                <img src="@/assets/images/scactive.svg" @click.stop="stockToggleClick(v)" v-if="v.collect" alt=""
                  class="mr-0.2rem cursor-pointer">
                <img src="@/assets/images/sc.png" alt="" @click.stop="stockToggleClick(v)" v-else
                  class="mr-0.2rem cursor-pointer">
                <img v-lazy="v.logo" alt="">
                <div class="stock-name">
                  <div>{{ v.short_name }}</div>
                  <div>{{ v.name }}</div>
                </div>
              </div>
              <div class="list-col2">
                <div class="list-text1"> {{ formatNumber(v.price) }} </div>
              </div>
              <div class="list-col3">
                <div class="list-text2" :class="{ zhang: v.changes_percentage < 0 }">
                  {{ Number(v.changes_percentage).toFixed(2) }}% </div>
              </div>
            </div>
            <div class="kong" v-if="!list.length">{{ t('index.a21') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- 体验金弹窗 -->
  <tyjPopup v-model:show="showPopup" :data="trial_info" @guanbi="showPopup = false" />
  <!-- otc弹窗 -->
  <notifyPopupOtc v-model:show="showPopup2" :data="otc_info" @guanbi="showPopup2 = false" />
  <!-- 系统提示 -->
  <notifyPopup v-model:show="showPopup3" :type="popType" :data="sys_info" @guanbi="showPopup3 = false" />
  <!-- 私信 -->
  <notifyPopupSx v-model:show="showPopup4" :type="popType" :data="remarkVal" @guanbi="showPopup4 = false"
    @receive="getTipsFun()" />
  <!-- 实名认证提示 -->
  <notifyPopupKyc v-model:show="showPopupSm" :data="kycData" @guanbi="showPopupSm = false" />
</template>

<script setup name="IndexPage">
import { send } from '@/ws'
import { useIndexWS } from '@/composables/useIndexWS'
import { formatUnit, exchangeRateConvert, formatNumber } from "@/utils/globalMethods"
import { usePolling } from "@/hooks/usePolling"
import { home, stockList, stockToggle, stockListCollect, getTips, stockPrice, indexsList, userAssets } from "@/api"
import { onMounted, ref, onBeforeUnmount } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n"
import { showSuccessToast } from "vant"
import { useMainStore } from "@/store"
import { eventBus } from '@/utils/eventBus'
const mainStore = useMainStore()
const { t } = useI18n()

const router = useRouter()

let webSocketSendSubsIndexs = [] //指数
let webSocketSendSubs = [] // 股票

// 客服
const service = computed(() => mainStore.service)
const openService = () => {
  eventBus.emit("openService", service.value)
}

const isShowAmount = ref(true)
const pageData = ref({
  "balance_ar": "0.00",
  "frozen_balance_ar": "0.00",
  "income_ar": "0.00",
  "stock_price_all": 0,
  "use_price": "0.00",
  "total_price": "0.00",
  "is_realname": 0,
  "pay": []
})
// 资产信息获取
const getPageData = () => {
  userAssets().then(res => {
    if (res.code == 200) {
      pageData.value = res.data
    }
  })
}
getPageData()

// 热门股票
const active = ref(2)

const username = ref()
const indexs = ref([])
const list = ref([])
const trial_info = ref({})
const otc_info = ref([])
const trial_info_home = ref({
  is_use: null
})
home().then(res => {
  if (res.code == 200) {
    username.value = res.data.username
    // indexs.value = res.data.indexs
    mainStore.setIs_collect(res.data.is_collect)
    mainStore.setRate(res.data.rate)
    if (res.data.trial_info) {
      trial_info_home.value = res.data.trial_info
    }
    if (mainStore.is_collect == 1) {
      active.value = 0
    }
    tabChange(active.value)
    // if(res.data.is_trial_top==1){
    //   trial_info.value = res.data.trial_info
    //   openPopup()
    // }
    // if(res.data.is_otc_top==1&&!mainStore.isOtcTc){
    //   otc_info.value = res.data.otc_info
    //   openPopup2()
    // }
  }
})
indexsList().then(res => {
  if (res.code == 200) {
    indexs.value = res.data.list
    webSocketSendSubsIndexs = indexs.value.map(v => {
      return { type: 'index', symbol: v.cfd_t }
    })
    let subs = webSocketSendSubs.concat(webSocketSendSubsIndexs)
    // send({
    //   action: 'subscribe',
    //   subs: subs
    // })
  }
})
// 监听 股票列表 订阅价格
watch(list, (newVal, oldVal) => {
  if (newVal.length) {
    webSocketSendSubs = newVal.map(v => {
      return { type: 'stock', symbol: v.short_name, country: v.country || 'US' }
    })
    let subs = webSocketSendSubs.concat(webSocketSendSubsIndexs)
    // send({
    //   action: 'subscribe',
    //   subs: subs
    // })
  }
})

// https 轮询订阅价格
let stock_symbolList = []
function getStockPrice() {
  stockPrice({
    stock_symbol: stock_symbolList
  }).then(res => {
    if (res.code == 200) {
      list.value.forEach((v) => {
        if (res.data[v.symbol]) {
          v.price = res.data[v.symbol]
          v.changes_percentage = ((Number(v.price) - Number(v.previous_close)) / Number(v.previous_close) * 100).toFixed(2)
        }
      })
    }
  })
}
const { start, stop } = usePolling(() => {
  return getStockPrice()
}, 2000)  // 3 秒轮询一次
start()
// https 轮询订阅价格end
// 排序
const sort = ref(0)
const sort_field = ref(undefined)
function getStockList(closeLoading) {
  list.value = []
  stockList({
    page: 1,
    size: 10,
    type: active.value == 2 ? 'US' : 'AR',
    sort_field: sort_field.value, //price价格排序  changes_percentage涨幅排序
    sort_order: sort.value == 1 ? 'asc' : sort.value == 2 ? 'desc' : undefined, //asc升序 desc 降序
  }, closeLoading).then(res => {
    if (res.code == 200) {
      list.value = res.data.list
      stock_symbolList = list.value.map(v => v.symbol)
    }
  })
}
// 自选
function getStockListCollect() {
  list.value = []
  stockListCollect({
    page: 1,
    size: 10,
    sort: 0
  }).then(res => {
    if (res.code == 200) {
      list.value = res.data.list
      stock_symbolList = list.value.map(v => v.symbol)
    }
  })
}

// 用户名加星号
function maskString(str) {
  if (!str) return "";

  const start = str.slice(0, 3);
  const end = str.slice(-4);

  return `${start}****${end}`;
}

function tabChange(e, closeLoading = false) {
  active.value = e
  if (active.value == 0) {
    getStockListCollect()
  } else {
    getStockList()
  }
}
// 排序
function sortClick(e) {
  if (e != sort_field.value) {
    sort_field.value = e
    sort.value = 0
  }
  sort.value++
  if (sort.value > 2) {
    sort.value = 0
  }
  getStockList()
}
// 收藏/取消
function stockToggleClick(v) {
  stockToggle({
    id: v.id,
    type: v.collect ? 2 : 1
  }).then(res => {
    if (res.code == 200) {
      if (v.collect) {
        v.collect = false
      } else {
        v.collect = true
        mainStore.setIs_collect(1)
      }
      if (active.value == 0) {
        tabChange(active.value, true)
      }
      setTimeout(() => {
        showSuccessToast(res.message)
      }, 50)
    }
  })
}

// 弹窗逻辑
const popType = ref("System") // 区分通知弹窗类型
const sys_info = ref([])
const remarkVal = ref({})
const userInfo = ref({})
const showPopupSm = ref(false)
const kycData = ref({})
function getUserInfo() {
  mainStore.getUserInfo().then(data => {
    userInfo.value = data
    lunxun()
    kfXX()
    openPopupFun(data)
  })
}
getUserInfo()

// 弹窗逻辑
function openPopupFun(data) {
  // 用户通知数组大于0，再分别判断每项的type，来显示对应的弹窗 需要提交已读
  const userNotices = data.user_notices || []
  const sysNotices = data.sys_notices || []
  // 需要处理的类型 [1, 2, 3, 4, 5, 9]
  // 分类
  const type1List = userNotices.filter(v => v.type === 1)
  const type2List = userNotices.filter(v => v.type === 2)
  const type3List = userNotices.filter(v => v.type === 3)
  const type4List = userNotices.filter(v => v.type === 4)
  const type5List = userNotices.filter(v => v.type === 5)
  const type9List = userNotices.filter(v => v.type === 9)
  const type10List = userNotices.filter(v => v.type === 10) //是否新用户
  const stype21List = userNotices.filter(v => v.stype === '2-1')
  const stype22List = userNotices.filter(v => v.stype === '2-2')
  const stype23List = userNotices.filter(v => v.stype === '2-3')

  // 处理 OTC 大宗交易弹窗队列
  handleOtcPopups([stype21List, stype22List, stype23List], showPopup2.value)
  // 体验金
  if (type5List.length > 0 && !mainStore.trialBalance) {
    trial_info.value = type5List[0]
    openPopup()
  }
  // 用户私信
  if (type9List.length > 0) {
    remarkVal.value = type9List[0]
    popType.value = "User"
    openPopup4()
  }
  // 系统通知 统一模板 不需要判断类型 不需要提交已读
  if (sysNotices.length > 0 && !mainStore.sysMessage) {
    popType.value = "System"
    sys_info.value = sysNotices
    openPopup3()
  }
  // 实名认证弹窗
  if (userInfo.value.is_realname == 0 && type10List.length > 0) {
    kycData.value = type10List[0]
    showPopupSm.value = true
  }
}
let otcList = []
function handleOtcPopups(listOfNotices, isPush) {
  // 过滤掉空或 null
  const arr = listOfNotices.filter(item => Array.isArray(item) && item.length > 0)
  if (isPush) {
    otcList = otcList.concat(arr)
  } else {
    otcList = arr
  }

  if (otcList.length === 0) return

  let index = 0
  function showNext() {
    if (index >= otcList.length) return
    otc_info.value = otcList[index]
    showPopup2.value = true  // 打开弹窗
    index++
  }

  // 监听弹窗关闭
  const stopWatch = watch(showPopup2, val => {
    if (!val) {
      // 延迟执行，保证下一个弹窗能显示
      setTimeout(() => {
        showNext()
        if (index >= otcList.length) {
          stopWatch() // 停止监听
        }
      }, 50)
    }
  })

  // 显示第一个
  showNext()
}

// 体验金
const showPopup = ref(false)
function openPopup() {
  showPopup.value = true
}
// otc弹窗
const showPopup2 = ref(false)
function openPopup2() {
  showPopup2.value = true
}
// 系统弹窗
const showPopup3 = ref(false)
function openPopup3() {
  showPopup3.value = true
}

// 私信
const showPopup4 = ref(false)
function openPopup4() {
  showPopup4.value = true
}

// 跳转外部链接
function goUrl() {
  window.open('https://www.fbi.gov/investigate', '_blank')
}

// 首页消息数量
const information = ref({})
const getTipsFun = () => {
  getTips().then(res => {
    if (res.code == 200) {
      information.value = res.data
    }
  })
}
getTipsFun()


// 客服未读
const noRead = ref(0)
const kfXX = async (outerSignal) => {
  const url = userInfo.value.service_url
  if (!url) return

  let timeout = null

  try {
    // 如果外面传来了 signal，直接用外部的 signal
    // 否则自己创建 controller 和超时机制

    const controller = new AbortController()
    timeout = setTimeout(() => controller.abort(), 10000) // 10s 超时

    const res = await fetch(url, {
      method: "GET",
      headers: {
        "accept": "application/json, text/plain, */*",
        "content-type": "application/json"
      },
      signal: controller.signal
    })

    // 仅在内部创建超时控制器时清除
    if (timeout) clearTimeout(timeout)

    if (!res.ok) {
      console.error(`客服接口错误 HTTP ${res.status}`)
      return null
    }

    const data = await res.json().catch(() => null)
    if (data?.status === 200) {
      noRead.value = data.data.noRead
    }

    return data

  } catch (err) {
    console.error("客服接口异常：", err)
    return null
  }
}

let timer = null
let currentController = null

function lunxun() {
  // 每次轮询开始前先清除旧的定时器
  if (timer) clearTimeout(timer)
  timer = setInterval(() => {
    kfXX()
  }, 10000)
}

// 停止轮询：既停止定时器，也终止当前请求
function stopLunxun() {
  if (timer) {
    clearInterval(timer)
    timer = null
  }
}

// ===== 初始化 WebSocket =====
let offWS = null
const initWebSocket = () => {
  offWS = useIndexWS({
    action: 'subscribe',
    subs: []
  }, res => {
    // console.log(res, '////');
    let data = {
      user_notices: [],
      sys_notices: []
    }

    if (res.type == 'user') {
      data.user_notices.push({
        ...res,
        wsType: res.type,
        stype: res.notice_stype,
        type: res.notice_type
      })
    }
    if (res.type == 'sys') {
      data.sys_notices.push({
        ...res,
        wsType: res.type,
        stype: res.notice_stype,
        type: res.notice_type
      })
    }
    openPopupFun(data)

    // 指数
    if (res.type == 'index') {
      indexs.value.forEach(v => {
        if (v.cfd_t == res.data.symbol) {
          v.price = res.data.c
          v.profit_and_Loss = v.price - v.previous_close
          if (v.previous_close <= 0) {
            v.increase = 0
          } else {
            v.increase = (v.price - v.previous_close) / v.previous_close * 100
          }
        }
      })
    }
    // 股票
    if (res.type == 'stock') {
      list.value.forEach(v => {
        if (v.short_name == res.data.symbol && v.country == res.data.co) {
          v.price = res.data.c
          if (v.previous_close <= 0) {
            v.changes_percentage = 0
          } else {
            v.changes_percentage = (v.price - v.previous_close) / v.previous_close * 100
          }
        }
      })
    }
  })
}
initWebSocket()
onBeforeUnmount(() => {
  offWS && offWS()
  stopLunxun()
})
</script>
<style lang="scss">
.banner-box {
  padding: 0 15px;

  .my-swipe {
    margin-top: 10px;

    .item {
      width: 358px;
      height: 120px;
      aspect-ratio: 358px / 140px;
      border-radius: 20px;
      overflow: hidden;

      .item-box {
        width: 100%;
        height: 100%;
        color: #fff;
        padding-top: 25px;
        padding-left: 15px;
        padding-right: 50px;

        .bg-video {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          z-index: 0;
        }

        .name,
        .msg {
          position: relative;
          z-index: 2;
        }

        &.item1 {}

        &.item2 {}

        &.item3 {
          background-image: url('@/assets/images/newbanner3.jpg');
          background-size: 100% 100%;
          padding-top: 20px;
          padding-left: 10px;

          span {
            color: #000 !important;
          }

          .name {
            color: #000;
          }

          .msg {
            color: #000;
            margin-top: 48px;
          }
        }

        .name {
          color: #FFF;
          font-family: Impact;
          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          display: flex;
          align-items: center;
          margin-bottom: 12px;

          span {
            color: #FFF;
            font-family: Inter;
            font-size: 20px;
            font-style: normal;
            font-weight: 700;
            line-height: 27px;
            margin-right: 5px;
          }
        }

        .msg {
          color: #FFF;
          text-shadow: 0 1px 0 #001789;
          font-family: Inter;
          font-size: 12px;
          font-style: normal;
          font-weight: 700;
          line-height: normal;
        }
      }
    }
  }
}
</style>
<style scoped lang="scss">
.page {
  padding-bottom: 100px;
  min-height: 100vh;

  .title {
    background-color: #f5f8fa;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 20px;

    .title-left {
      width: 119px;
      display: flex;
      align-items: center;
      font-size: 30px;
      font-weight: 700;
      color: #000;
      gap: 10px;

      .logo-demo {
        display: flex;
        align-items: center;
        gap: 10px;
        color: #000;
        font-size: 20px;

        img {
          width: 140px;
        }
      }
    }

    .title-right {
      display: flex;
      align-items: center;
      gap: 11px;

      .title-right-text-box {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;

        .title-right-text {
          text-align: right;

          div {
            color: #999;
            font-family: Montserrat;
            font-size: 12px;
            font-style: normal;
            font-weight: 500;
            line-height: 18px;
            letter-spacing: -.165px;
          }
        }

        .img2 {
          width: 43px;
          height: 43px;
        }
      }

      .title-img-box {
        padding: 5px 7px;
        // background-color: #fff;
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        img {
          width: 18px;
        }
      }
    }
  }



  .content-box {
    .menu2 {
      padding: 0 15px 5px;
      margin-top: 15px;

      :deep(.van-grid-item__content) {
        background-color: rgba(0, 0, 0, 0);
        padding: 4px 8px !important;
        height: 100%;
      }

      :deep(.van-grid-item__content--center) {
        justify-content: flex-start;
      }

      .icon-box {
        border-radius: 50%;
        width: 50px;
        height: 50px;
        background-color: #fff;
        // border: 1px solid #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        // overflow: hidden;
        position: relative;

        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }

        .gantanhao {
          width: 16px;
          position: absolute;
          right: -2px;
          top: -15px;
          margin: auto;
        }
      }

      .text-box {
        margin-top: 10px;
        font-size: 12px;
        font-weight: 350;
        text-align: center;
        letter-spacing: 0;
        color: #000;
      }
    }

    .qqzs {
      .popular-stocks {
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #8e8e8e;
        font-size: 14px;
        margin: 15px 15px 10px;

        .text {
          color: #000;
          font-size: 18px;
          font-weight: 700;
        }
      }


    }

    .list-page {
      margin: 0 15px;
      border-radius: 10px;

      .list-page-tabs {
        font-family: Inter;
        font-size: 14px;
        color: #000;
        display: flex;
        align-items: center;
        gap: 15px;
        padding-bottom: 15px;
        overflow-y: hidden;
        white-space: nowrap;
        -webkit-overflow-scrolling: touch;
        cursor: grab;
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
        overflow-x: auto;
        scroll-behavior: smooth;
        scrollbar-width: none;
        -ms-overflow-style: none;

        .list-page-tabs-item {
          padding: 5px 15px;
          box-sizing: border-box;
          color: #2969FF;
          background: #fff;
          border-radius: 4px;
          font-size: 13px;
          border: 1px solid #2969FF;

          &.selected {
            color: #fff;
            font-weight: 500;
            background: #2969FF;
            position: relative;
          }
        }
      }

      .list-th {
        display: flex;
        margin-top: 15px;
        margin-bottom: 5px;
        gap: 10px;
        padding-left: 20px;

        div {
          font-size: 12px;
          font-weight: 400;
          line-height: normal;
          letter-spacing: normal;
          color: #a2a7aa;
          width: calc(50% - 20px);
        }

        div:nth-child(2) {
          width: 25%;
        }

        .list-th-right {
          display: flex;
          align-content: center;
          justify-content: center;
        }

        div:last-child {
          width: 25%;
          text-align: right;
        }

        .list-th-right-icon {
          display: flex;
          align-content: center;
          justify-content: center;
          flex-direction: column;
          position: relative;

          .icon-fall {
            margin-top: -3px;
          }

          .icon {
            font-size: 11px;
          }
        }
      }


      .list {
        opacity: 1;
        box-sizing: border-box;

        .list-row {
          display: flex;
          align-items: center;
          padding: 10px 20px;
          background: #fff;
          margin-bottom: 15px;
          border-radius: 10px;
          gap: 10px;

          .list-col1 {
            width: 55%;
            display: flex;
            align-items: center;
            gap: 5px;

            .cursor-pointer {
              width: 18px;
              height: 18px;
            }

            img {
              width: 40px;
              height: 40px;
              border-radius: 20px;
            }

            .stock-name {
              margin-left: 10px;
              font-size: 11px;
              flex: 1;
              overflow: hidden;
              color: #000;
              font-weight: 700;

              div:last-child {
                font-size: 12px;
                color: #666;
                font-weight: 400;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                /* 最多显示3行 */
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }

          .list-col2 {
            width: 25%;

            .list-text1 {
              font-size: 14px;
              font-weight: 600;
              letter-spacing: 0;
              color: #000;
              transition: transform .3s ease;
            }
          }

          .list-col3 {
            width: 20%;
            word-wrap: break-word;

            .list-text2 {
              font-family: Poppins;
              font-size: 16px;
              font-weight: 900;
              line-height: 18px;
              text-align: right;
              letter-spacing: 0;
              color: #15b384;
              white-space: nowrap;
              transition: transform .3s ease;

              &.zhang {
                color: #cb0000;
              }
            }
          }
        }

        .kong {
          margin: 80px 0;
          text-align: center;
          font-size: 14px;
          color: #969799;
        }
      }
    }

  }
}

.kyc {
  width: calc(100% - 30px);
  margin-left: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  background: linear-gradient(0deg, #FFF 0%, #FFF 100%), linear-gradient(180deg, #FFF 0%, #E4F1FF 100%);
  margin-top: 10px;
  padding: 4px 8px;
  gap: 8px;

  .lf {
    width: 50px;
    height: 50px;
    overflow: hidden;

    img {
      width: 100%;
    }
  }

  .center {
    display: flex;
    flex-direction: column;
    gap: 3px;

    .ps {
      color: #010611;
      // text-align: center;
      font-family: "Microsoft YaHei UI";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
    }

    .btnt {
      color: #000;
      font-family: "Microsoft YaHei UI";
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 16px;
      display: flex;
      align-items: center;
      gap: 8px;

      img {
        width: 18px;
      }
    }
  }

  .rg {
    width: 66px;
    height: 70px;
    overflow: hidden;

    img {
      width: 100%;
    }
  }
}

.zc-box {
  width: calc(100% - 30px);
  margin-left: 15px;

  border-radius: 8px;
  background: linear-gradient(180deg, #CADFFF 0%, #FFF 78.63%);
  margin-top: 10px;

  .zc-con {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-start;
    padding: 14px 20px 18px 20px;
    width: 100%;
    height: 100%;
    background-image: url("@/assets/images/zcrbg.png");
    background-size: 133px;
    background-position: right top;
    background-repeat: no-repeat;
    gap: 17px;

    .name {
      color: #000;
      font-family: "Microsoft YaHei UI";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 16px;
      display: flex;
      align-items: center;
      gap: 8px;

      .icon {
        font-size: 16px;
      }
    }

    .value {
      color: #000;
      leading-trim: both;
      text-edge: cap;
      font-family: "Microsoft YaHei UI";
      font-size: 28px;
      font-style: normal;
      font-weight: 700;
      line-height: 16px;
      display: flex;
      gap: 10px;

      .yk-val {
        display: flex;
        padding: 3px 9px;
        align-items: center;
        gap: 2px;
        border-radius: 5000px;
        background: #EC3E33;
        color: #FFF;
        text-align: center;
        font-family: "Microsoft YaHei UI";
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 16px;
        position: relative;
        padding-left: 25px;

        &.zlass {
          background: #15b384;

          &::after {
            content: '';
            display: block;
            width: 0;
            height: 0;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-bottom: 6px solid #fff;
            position: absolute;
            left: 9px;
            top: 0;
            bottom: 0;
            margin: auto;
          }
        }

        &.dlass {
          background: #EC3E33;

          &::after {
            content: '';
            display: block;
            width: 0;
            height: 0;
            border-left: 5px solid transparent;
            border-right: 5px solid transparent;
            border-top: 6px solid #fff;
            position: absolute;
            left: 9px;
            top: 0;
            bottom: 0;
            margin: auto;
          }
        }
      }
    }
  }
}
</style>
